import { NavLink, Outlet, useParams } from 'react-router-dom';
import { useApp, useAsync } from '../lib/app-context';
import { isSuperAdmin } from '../lib/types';
import { Badge } from './ui';

export function Shell() {
    const { data, user, setUser } = useApp();
    const { moduleId } = useParams();
    const modules = useAsync(() => data.listModules(), [user?.id]);

    const current = modules.data?.find((m) => m.id === moduleId);
    const isMock = data.label.startsWith('Mock');

    return (
        <div className="shell">
            <aside className="sidebar">
                <div className="brand">
                    <div className="brand-mark">▽</div>
                    <div>
                        <div style={{ fontWeight: 800 }}>Strength Pool</div>
                        <div className="small muted">Admin</div>
                    </div>
                </div>

                <nav className="nav">
                    <NavLink to="/modules" end>Modules</NavLink>
                </nav>

                {current && (
                    <div className="nav nav-section">
                        <div className="eyebrow" style={{ padding: '0 10px 6px' }}>
                            {current.name}
                        </div>
                        <NavLink to={`/modules/${current.id}`} end>Overview</NavLink>
                        <NavLink to={`/modules/${current.id}/exercises`}>Exercises</NavLink>
                        <NavLink to={`/modules/${current.id}/sessions`}>Sessions</NavLink>
                        <NavLink to={`/modules/${current.id}/programme`}>Programme</NavLink>
                        <NavLink to={`/modules/${current.id}/studies`}>Skill studies</NavLink>
                        <NavLink to={`/modules/${current.id}/skills`}>Skill tree</NavLink>
                        <NavLink to={`/modules/${current.id}/publish`}>
                            Publish
                            {!current.live_version_id && <Badge tone="coral">draft</Badge>}
                        </NavLink>
                    </div>
                )}

                <div className="spacer" />

                <div className="stack" style={{ gap: 8 }}>
                    <div className={`source-chip${isMock ? ' mock' : ''}`}>
                        {isMock ? 'Mock data — no backend' : 'Live: Supabase'}
                    </div>
                    {user && (
                        <div className="card card-tight" style={{ boxShadow: 'none' }}>
                            <div className="small" style={{ fontWeight: 600, wordBreak: 'break-all' }}>
                                {user.email}
                            </div>
                            <div style={{ marginTop: 6 }}>
                                <Badge tone={isSuperAdmin(user) ? 'coral' : 'teal'}>
                                    {isSuperAdmin(user) ? 'Super admin' : 'Module owner'}
                                </Badge>
                            </div>
                            <button
                                className="btn secondary small"
                                style={{ marginTop: 10, width: '100%' }}
                                onClick={async () => { await data.signOut(); setUser(null); }}
                            >
                                Sign out
                            </button>
                        </div>
                    )}
                </div>
            </aside>

            <main className="content">
                <Outlet />
            </main>
        </div>
    );
}
